import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import Raven from 'raven-js';
import { CookiesProvider } from 'react-cookie';

Raven.config(
  process.env.REACT_APP_SENTRY_KEY,{
    environment: process.env.NODE_ENV
  }
).install();

ReactDOM.render(
  <CookiesProvider>
    <App />
  </CookiesProvider>,
  document.getElementById('root')

);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js